<template>
    <v-container>
         <v-row
            align="center"
            justify="center"
        >
            <img
                height="150"
                width="300"
                src="/soundanalytics.svg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Creación de usuario
                    </v-card-title>
                    <v-card-text v-if="isCode">
                      <v-text-field
                          label="Correo electrónico"
                          type="text"
                          outlined
                          dense
                          v-model="email"
                          :rules="emailRules"
                          required
                      ></v-text-field>

                      <pin-input 
                          v-model="pinCode"
                          @complete="onComplete"
                      />
                    </v-card-text>
                    <v-card-text v-else>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                           <v-text-field
                                label="Nombre de usuario"
                                type="text"
                                outlined
                                dense
                                v-model="username"
                                :rules="userRules"
                                required
                            ></v-text-field>

                            <v-text-field
                                label="Contraseña"
                                outlined
                                dense
                                v-model="password"
                                :rules="passRules"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                required
                            ></v-text-field>
                            <v-text-field
                                label="Confirmacion contraseña"
                                outlined
                                dense
                                v-model="confirmPassword"
                                :rules="confirmPasswordRules"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                required
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-if="isCode">
                        <v-btn
                            width="95%"
                            color="success"
                            class="ma-2"
                            @click="resendCode"
                        >
                            Solicitar nuevo código
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions v-else>
                        <v-btn
                            v-if="!successRegister"
                            width="95%"
                            color="success"
                            class="ma-2"
                            :loading="isLoading"
                            @click="createUser"
                            :disabled="!valid"
                        >
                            Crear
                        </v-btn>
                        <v-btn
                            v-else
                            width="95%"
                            color="success"
                            class="ma-2"
                            @click="goLogin"
                            :disabled="!valid"
                        >
                            Ir login
                        </v-btn>
                    </v-card-actions>
                    <v-card-text align="center">
                        ¿Tienes alguna duda? <a> Contactanos </a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics
            </p>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment'
import PinInput from '../components/PinInput'

export default {
    name: 'CreateUser',
    data: () => ({
        mode: 'code',
        email: '',
        pinCode: '',
        valid: false,
        username: '',
        password: '',
        confirmPassword: '',
        showPass: false,
        emailRules: [
            v => !!v || 'E-mail es requerido',
            v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
        ],
        userRules: [
            v => !!v || 'Usuario es requerido',
            v => (v && v.length > 5) || 'Nombre de usuario debe tener mas de 5 caracteres',
            v => /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/.test(v) || "Solo puede tener letras, numeros y '_'",
        ],
        passRules: [
            v => !!v || 'Password requerido',
            v => (v && v.length > 8) || 'Password debe tener más de 8 caracteres',
            v => /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v) || 'Password debe contener al menos una letra y un número',
        ],
    }),

    methods: {
        async onComplete(code) {
            console.log('Código completo:', code)

            try {
                const response = await this.$store.dispatch('sendEmailCode', {
                    type: 'createuser',
                    email: this.email,
                    code: code
                })
                
                if (!response)
                    return

                this.token = response
                this.mode = 'create'
                console.log(response)
            } catch (error) {
                console.log(error)
            }
        },

        async resendCode () {
            try {
                await this.$store.dispatch('sendEmailReSendCode', {
                    email: this.email,
                    type: 'createuser'
                })
            } catch (error) {
                console.log(error)
            }
        },

        createUser () {
            const payload = {
                username: this.username.toLowerCase().trim(),
                password: this.password,
                token: this.token
            }

            const isValid = this.$refs.form.validate()

            if (isValid)
                this.$store.dispatch('register', payload)
        },

        urlEmail () {
          try {
            const userB64 = this.$route.query.user
            const user = atob(userB64)
            const isEmail = user.includes('@')

            if (isEmail)
                this.email = user
          } catch (error) {}
        },
        goLogin () {
            this.$router.push('/login')
        }
    },

    computed: {
        isCode () {
            return this.mode === 'code'
        },
        isLoading () {
            return this.$store.getters.loadRegister
        },
        errorRegister () {
            return this.$store.getters.errorRegister
        },
        successRegister () {
            return this.$store.getters.successRegister
        },
        confirmPasswordRules() {
            return [
                v => !!v || 'Confirmar password',
                v => v === this.password || 'Password no coinciden',
            ]
        },
        currentYear () {
            return moment().format("YYYY")
        }
    },
    
    filters: {
        lowerCase (value) {
            if (!value) return ''
            value = value.toString()
            return value.toLowerCase().trim()
        }
    },

    components: {
        PinInput
    },

    created () {
        this.urlEmail()
        moment.locale('es-us')
    }
}
</script>
